import React, { FC, useState } from 'react'
import t from '../../../translations/main'
import Font from 'src/components/Core/Typography/Font/Font'
import MaxWidthWrapper from 'src/components/Layout/MaxWidthWrapper/MaxWidthWrapper'
import ProgressBar from 'src/components/Molecules/ProgressBar/ProgressBar'
import {
  Content,
  PageHeaderSection,
  PageHeader,
  SubTitle,
} from './Onboarding.styles'
import { OnboardingWrapperProps } from './types'
import OnboardingChatPanel from './Chat/OnboardingChatPanel'
import storage from 'src/components/Core/Utils/storage'
import { checkMode } from 'src/components/Organisms/Form/utils'

const OnboardingWrapper: FC<OnboardingWrapperProps> = props => {
  const [enableReverse, setEnableReverse] = useState(false)

  const {
    isWarning,
    isDone,
    completedStepList,
    stepName,
    applicationType,
    setOptionsList,
    setRefetch
  } = props
  const userPermission: string = storage.get(storage?.keys?.onboarding?.prospectPermission)
  const showCommentsButton = stepName === 'SignatureForm' ? checkMode('enableCommentsOnSignature') : checkMode('enableComments')
  return (
    <>
      <Content flexDirection='column'>
        <PageHeaderSection>
          <PageHeader>
            <Font tag='h2'>{t('onboarding.main.title')}</Font>
            <SubTitle>{t('onboarding.main.subtitle')}</SubTitle>
          </PageHeader>
          <ProgressBar
            isWarning={isWarning}
            isDone={isDone}
            stepList={completedStepList}
          />
        </PageHeaderSection>
        <MaxWidthWrapper alignItems='flex-start'>
          {props.children}
        </MaxWidthWrapper>
        {
          showCommentsButton &&
            <OnboardingChatPanel
              userPermission={userPermission}
              stepName={stepName}
              applicationType={applicationType}
              setOptionsList={setOptionsList}
              setRefetch={setRefetch}
              enableReverse={enableReverse}
              setEnableReverse={setEnableReverse}
            />
        }
      </Content>
    </>
  )
}

OnboardingWrapper.defaultProps = {
  isDone: false,
  isWarning: false,
}

export default OnboardingWrapper
